import { Injectable } from '@angular/core'
import { CanActivate, Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from '../services/external/auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // Vérifie si l'utilisateur est déjà connecté
    if (this.authService.authState().state === 'SignedIn') {
      // Si connecté, redirige vers /map
      return this.router.createUrlTree(['/map'])
    }

    // Si non connecté, permet l'accès à la route
    return true
  }
}
